import { ProviderTypeOption } from "@/components/PageHeader/actions/dialogs/integrations/IntegrationTypeDialog/types/interfaces";

import {
  Column,
  COLUMN_NAMES,
  COLUMN_RESOURCES,
  ROUTES,
  TabsType
} from "../../shared";
import {
  ANALYSIS_PROVIDER_NAMES,
  ANALYSIS_RPOVIDER_DISPLAY_NAMES
} from "./types/enums";

export const INTEGRATIONS_TABLE_COLUMNS: Column[] = [
  {
    name: COLUMN_NAMES.Name,
    isSticky: true,
    resource: COLUMN_RESOURCES.Name,
    sortResource: COLUMN_RESOURCES.Name,
    isDefaultActive: true
  },
  {
    name: COLUMN_NAMES.Method,
    isSticky: false,
    resource: COLUMN_RESOURCES.Type,
    sortResource: COLUMN_RESOURCES.Type,
    isDefaultActive: true
  },
  {
    name: COLUMN_NAMES.Company,
    isSticky: false,
    resource: COLUMN_RESOURCES.Company,
    isDefaultActive: true
  },
  {
    name: COLUMN_NAMES.Status,
    isSticky: false,
    resource: COLUMN_RESOURCES.Status,
    sortResource: COLUMN_RESOURCES.Status,
    isDefaultActive: true,
    isBadge: true
  },
  {
    name: COLUMN_NAMES.LastEvent,
    isSticky: false,
    resource: COLUMN_RESOURCES.LastEvent,
    sortResource: COLUMN_RESOURCES.LastEvent,
    isDefaultActive: true
  }
];

export const INTEGRATIONS_PAGE_TABS: TabsType[] = [
  {
    label: "Tabs##sftp",
    route: ROUTES.Integrations
  },
  {
    label: "Tabs##api",
    route: ROUTES.IntegrationsApi
  },
  {
    label: "Tabs##analysis providers",
    route: ROUTES.AnalysisProviders
  }
];

export const INTEGRATIONS_PAGE_TABS_PARTIAL: TabsType[] = [
  {
    label: "Tabs##sftp",
    route: ROUTES.Integrations
  },
  {
    label: "Tabs##api",
    route: ROUTES.IntegrationsApi
  }
];

export const ANALYSIS_PROVIDER_OPTIONS: ProviderTypeOption[] = [
  {
    id: ANALYSIS_PROVIDER_NAMES.Convey,
    name: ANALYSIS_PROVIDER_NAMES.Convey,
    value: ANALYSIS_PROVIDER_NAMES.Convey,
    description: "Convey-tech"
  },
  {
    id: ANALYSIS_PROVIDER_NAMES.VDO,
    name: ANALYSIS_RPOVIDER_DISPLAY_NAMES.VDO,
    value: ANALYSIS_PROVIDER_NAMES.VDO,
    description: "Continental VDO"
  }
];

export const ANALYSIS_PROVIDER_OPTIONS_PROD: ProviderTypeOption[] = [
  {
    id: ANALYSIS_PROVIDER_NAMES.Convey,
    name: ANALYSIS_PROVIDER_NAMES.Convey,
    value: ANALYSIS_PROVIDER_NAMES.Convey,
    description: "Convey-tech"
  }
];
